(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["motionbar-cart-confidence"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initMotionBarCartTotal = () => {
      document.querySelectorAll('.mb-cart-confidence:not([data-total-sync-initialized])').forEach((root) => {
        root.dataset.totalSyncInitialized = 'true';
        const stickyTotal = root.querySelector('[data-motionbar-cart-total]');
        if (!stickyTotal) return;

        const syncTotal = () => {
          const footerTotal = document.querySelector('#main-cart-footer .totals__total-value, .cart__footer .totals__total-value');
          const value = footerTotal?.textContent?.trim();
          if (value && value !== stickyTotal.textContent.trim()) {
            stickyTotal.textContent = value;
          }
        };

        ['#main-cart-items', '#main-cart-footer'].forEach((selector) => {
          const target = document.querySelector(selector);
          if (target) {
            new MutationObserver(syncTotal).observe(target, {
              childList: true,
              subtree: true,
              characterData: true
            });
          }
        });

        document.addEventListener('change', (event) => {
          if (event.target.closest('#main-cart-items, cart-items, .cart-items')) {
            window.setTimeout(syncTotal, 50);
            window.setTimeout(syncTotal, 400);
          }
        });

        document.addEventListener('click', (event) => {
          if (event.target.closest('cart-remove-button, .cart-remove-button')) {
            window.setTimeout(syncTotal, 100);
            window.setTimeout(syncTotal, 500);
          }
        });

        syncTotal();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMotionBarCartTotal, { once: true });
    } else {
      initMotionBarCartTotal();
    }

    document.addEventListener('shopify:section:load', initMotionBarCartTotal);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["motionbar-sticky-cart"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeStickyCarts = () => {
      document.querySelectorAll('[data-motionbar-sticky-cart]:not([data-initialized])').forEach((root) => {
        root.dataset.initialized = 'true';
        const stickyButton = root.querySelector('[data-sticky-button]');
        const stickyPrice = root.querySelector('[data-sticky-price]');
        const getProductForm = () => document.querySelector('.product__info-container product-form form[data-type="add-to-cart-form"], product-form form[action*="/cart/add"]');
        const getMainButton = () => getProductForm()?.querySelector('[name="add"], button[type="submit"]');
        const getMainPrice = () => document.querySelector('.product__info-container .price');

        if (!stickyButton || !getMainButton()) return;

        const sync = () => {
          const mainButton = getMainButton();
          const mainPrice = getMainPrice();
          if (!mainButton) return;
          const disabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
          stickyButton.disabled = disabled;
          const mainLabel = mainButton.querySelector('span')?.textContent?.trim() || mainButton.textContent?.trim();
          stickyButton.textContent = mainLabel || (disabled ? root.dataset.soldLabel : root.dataset.addLabel);
          const salePrice = mainPrice?.querySelector('.price__sale .price-item--sale')?.textContent?.trim();
          const regularPrice = mainPrice?.querySelector('.price__regular .price-item--regular, .price-item--regular')?.textContent?.trim();
          const activePrice = salePrice || regularPrice;
          if (activePrice && stickyPrice) stickyPrice.textContent = activePrice;
        };

        const updateVisibility = () => {
          const mainButton = getMainButton();
          if (!mainButton) return;
          const rect = mainButton.getBoundingClientRect();
          const passedButton = rect.bottom < 0;
          root.classList.toggle('is-visible', passedButton);
          root.setAttribute('aria-hidden', passedButton ? 'false' : 'true');
        };

        stickyButton.addEventListener('click', () => {
          sync();
          const mainButton = getMainButton();
          if (!stickyButton.disabled && mainButton) mainButton.click();
        });

        document.addEventListener('change', (event) => {
          if (event.target.closest('.product')) {
            window.setTimeout(() => {
              sync();
              updateVisibility();
            }, 300);
          }
        });

        const productArea = document.querySelector('.product');
        if (productArea) {
          new MutationObserver(() => {
            sync();
            updateVisibility();
          }).observe(productArea, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['aria-disabled', 'disabled'],
          });
        }
        window.addEventListener('scroll', updateVisibility, { passive: true });
        window.addEventListener('resize', updateVisibility, { passive: true });
        sync();
        updateVisibility();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeStickyCarts, { once: true });
    } else {
      initializeStickyCarts();
    }
    document.addEventListener('shopify:section:load', initializeStickyCarts);
  })();

  } catch(e) { console.error(e); }
})();
})();
